import { Component, inject, Inject, Input } from '@angular/core';
import { ActivatedRoute, Router, RouterLink, RouterLinkActive } from '@angular/router';
import { MatCardModule } from '@angular/material/card';
import { MatTableDataSource, MatTableModule } from '@angular/material/table'
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon'
import { MatExpansionModule } from '@angular/material/expansion'
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox'
import { MatMenuModule } from '@angular/material/menu'
import { MatInputModule } from '@angular/material/input'
import { MatFormField } from '@angular/material/input';
import { MatDividerModule } from '@angular/material/divider'
import { MatChipsModule } from '@angular/material/chips'
import { AsyncPipe, CommonModule, DatePipe, TitleCasePipe } from '@angular/common';
import { BehaviorSubject, map, Observable, tap } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AppointmentComponent } from '../appointment/appointment.component';
import { EncounterServiceService } from '../patient-wrapper/encounter-service.service';
import { AppointmentUiComponent } from '../appointment-ui/appointment-ui.component';
import { DashboardAppointmentSummary, DoctorDashboardService, DashboardTaskSummary } from '../doctors-dashboard/doctor-dashboard.service';
import { ReferenceDisplayDirective } from '../shared/reference-display.directive';


@Component({
  selector: 'app-serviceprovider-dashboard',
  imports: [MatCardModule, MatButtonModule,
    MatFormField, MatDividerModule, DatePipe, RouterLink,
    RouterLinkActive, CommonModule, AppointmentComponent,
    MatExpansionModule, MatCheckboxModule, TitleCasePipe,
    MatTableModule, AsyncPipe,
    MatChipsModule,
    MatInputModule, AppointmentUiComponent,
    MatMenuModule,
    MatTableModule, MatIconModule, ReactiveFormsModule, ReferenceDisplayDirective],
  templateUrl: './serviceprovider-dashboard.component.html',
  styleUrl: './serviceprovider-dashboard.component.scss'
})
export class ServiceproviderDashboardComponent {
  @Input() isConsultant: boolean = false;
  encounterService = inject(EncounterServiceService);
  private dashboardService = inject(DoctorDashboardService);
  nextAppointments$: Observable<DashboardAppointmentSummary[]> = this.dashboardService.getNextAppointmentsForCurrentPractitioner$(3);
  nextTasks$: Observable<DashboardTaskSummary[]> = this.dashboardService.getNextTasksForCurrentUser$(3);


}
''
